var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-container',{staticClass:"CustomMod"},[_c('ui-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }